import React, { useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { TextFormat } from 'react-jhipster';
import { Link, useParams } from 'react-router';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './mensaje.reducer';

export const MensajeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id!));
  }, []);

  const mensajeEntity = useAppSelector(state => state.mensaje.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="mensajeDetailsHeading">Mensaje</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{mensajeEntity.id}</dd>
          <dt>
            <span id="nombreCliente">Nombre Cliente</span>
          </dt>
          <dd>{mensajeEntity.nombreCliente}</dd>
          <dt>
            <span id="numeroCelular">Numero Celular</span>
          </dt>
          <dd>{mensajeEntity.numeroCelular}</dd>
          <dt>
            <span id="referencia">Referencia</span>
          </dt>
          <dd>{mensajeEntity.referencia}</dd>
          <dt>
            <span id="concepto">Concepto</span>
          </dt>
          <dd>{mensajeEntity.concepto}</dd>
          <dt>
            <span id="monto">Monto</span>
          </dt>
          <dd>{mensajeEntity.monto}</dd>
          <dt>
            <span id="timestampLimite">Timestamp Limite</span>
          </dt>
          <dd>
            {mensajeEntity.timestampLimite ? (
              <TextFormat value={mensajeEntity.timestampLimite} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="timestampSolicitud">Timestamp Solicitud</span>
          </dt>
          <dd>
            {mensajeEntity.timestampSolicitud ? (
              <TextFormat value={mensajeEntity.timestampSolicitud} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="idMensajeCobro">Id Mensaje Cobro</span>
          </dt>
          <dd>{mensajeEntity.idMensajeCobro}</dd>
          <dt>
            <span id="edoPet">Edo Pet</span>
          </dt>
          <dd>{mensajeEntity.edoPet}</dd>
          <dt>
            <span id="extra1">Extra 1</span>
          </dt>
          <dd>{mensajeEntity.extra1}</dd>
          <dt>
            <span id="extra2">Extra 2</span>
          </dt>
          <dd>{mensajeEntity.extra2}</dd>
          <dt>
            <span id="extra3">Extra 3</span>
          </dt>
          <dd>{mensajeEntity.extra3}</dd>
          <dt>
            <span id="extra4">Extra 4</span>
          </dt>
          <dd>{mensajeEntity.extra4}</dd>
          <dt>
            <span id="extra5">Extra 5</span>
          </dt>
          <dd>{mensajeEntity.extra5}</dd>
          <dt>
            <span id="extra6">Extra 6</span>
          </dt>
          <dd>{mensajeEntity.extra6}</dd>
          <dt>
            <span id="extra7">Extra 7</span>
          </dt>
          <dd>{mensajeEntity.extra7}</dd>
          <dt>
            <span id="extra8">Extra 8</span>
          </dt>
          <dd>{mensajeEntity.extra8}</dd>
          <dt>
            <span id="extra9">Extra 9</span>
          </dt>
          <dd>{mensajeEntity.extra9}</dd>
          <dt>
            <span id="extra10">Extra 10</span>
          </dt>
          <dd>{mensajeEntity.extra10}</dd>
          <dt>
            <span id="createdBy">Created By</span>
          </dt>
          <dd>{mensajeEntity.createdBy}</dd>
          <dt>
            <span id="createdDate">Created Date</span>
          </dt>
          <dd>
            {mensajeEntity.createdDate ? <TextFormat value={mensajeEntity.createdDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="lastModifiedBy">Last Modified By</span>
          </dt>
          <dd>{mensajeEntity.lastModifiedBy}</dd>
          <dt>
            <span id="lastModifiedDate">Last Modified Date</span>
          </dt>
          <dd>
            {mensajeEntity.lastModifiedDate ? (
              <TextFormat value={mensajeEntity.lastModifiedDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>Cliente</dt>
          <dd>{mensajeEntity.cliente ? mensajeEntity.cliente.nombre : ''}</dd>
        </dl>
        <Button as={Link as any} to="/mensaje" replace variant="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button as={Link as any} to={`/mensaje/${mensajeEntity.id}/edit`} replace variant="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default MensajeDetail;
